// extracted by mini-css-extract-plugin
module.exports = {"container":"initial_container__1UYu0","sectionArea":"initial_sectionArea__FHJ9g","sectionBlock":"initial_sectionBlock__2VJnu","loading":"initial_loading__T_KXt"};